import { SolvedFieldsRatioLabel } from 'components/common-form/builder/form/node/field/SolvedFieldsRatioLabel';
import { ShareButtonNext } from 'components/common-form/sidePanel/docToolbar/summary';
import { FxSpot } from 'components/common-form/sidePanel/status/fxSpotUtils';
import { useClassNameFromTradeWay } from 'components/common-form/sidePanel/status/useClassNameFromTradeway';
import { PricedOn } from 'components/shared/Price/Price';
import {
  ConnectedTradeWayLiteral,
  FlowWayLiteral,
  PriceNext,
  QuoteStatus,
  QuoteYield,
  SolveResult,
} from 'components/shared/PriceNext';
import { FC, PropsWithChildren } from 'react';

import { SolveModeLabel } from '../SolveMode';
import type { QuotedState } from './Quoted.Indicative.connect';
import { connectQuotedIndicative } from './Quoted.Indicative.connect';

export const Component: FC<PropsWithChildren<QuotedState>> = ({
  tabId,
  quoteType,
  solveResult,
  solveResultFormat,
  solvingMode,
  isMultipleSolvingMode,
  workspaceType,
  pricedOn,
  flowWay,
  fxSpot,
  priceInPercent = 0,
  priceInCurrency = 0,
  currency = '',
  quoteYield,
}) => {
  const className = useClassNameFromTradeWay(tabId, workspaceType);
  const isDynamicWorkspace = workspaceType === 'dynamic';

  return (
    <PriceNext
      className={className}
      tradeWay={<ConnectedTradeWayLiteral tabId={tabId} workspaceType={workspaceType} />}
      solveMode={
        <SolveModeLabel
          workspaceType={workspaceType}
          solvingMode={solvingMode}
          isMultipleSolvingMode={isMultipleSolvingMode}
        />
      }
      shareButton={!isDynamicWorkspace && <ShareButtonNext className={className} tabId={tabId} />}
      solveResult={<SolveResult price={solveResult} priceFormat={solveResultFormat} />}
      fxSpot={<FxSpot greekLine={fxSpot} />}
      solveRatio={<SolvedFieldsRatioLabel className="fw-extrabold align-middle" e2e="solving-fields-ratio" />}
      flowWay={
        <FlowWayLiteral
          flowWay={flowWay}
          priceInPercent={priceInPercent}
          priceInCurrency={priceInCurrency}
          currency={currency}
        />
      }
      pricedOn={<PricedOn className="fs-12" pricedOn={pricedOn} />}
      quoteYield={<QuoteYield yieldValue={quoteYield} />}
      quoteStatus={quoteType && <QuoteStatus icon="info_outline" description={`sidePanel.quoteType.${quoteType}`} />}
    />
  );
};

export const QuotedIndicativeComponent = connectQuotedIndicative(Component);

Component.displayName = 'QuotedIndicative';
